import React from 'react';
import cn from 'classnames';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AdvancedSearchContentTypeIcon from './AdvancedSearchContentTypeIcon';
import AdvancedSearchResultCardStatus from './AdvancedSearchResultCardStatus';

export default function ContentTypeAndStatus({
  state,
  contentType,
  certificationId,
  isHorizontal,
}) {
  const TYPE_TO_DISPLAY = {
    lesson: t('common.lesson'),
    path: t('common.path'),
    resource: t('common.resource'),
    practice_container: t('common.scenario'),
    scorm: t('common.scorm.upcase'),
    certification: t('common.certification'),
    draft_lesson: t('common.lesson'),
  };

  const contentTypeText = () => {
    switch (contentType) {
      case 'path':
        return certificationId
          ? TYPE_TO_DISPLAY.certificationPath
          : TYPE_TO_DISPLAY[contentType];
      case 'lesson':
        return TYPE_TO_DISPLAY[contentType];
      default:
        return TYPE_TO_DISPLAY[contentType];
    }
  };

  const typeText = contentTypeText();
  const shouldShowType = typeText && contentType;

  return (
    <div
      className={cn('mt-a d-f', {
        'fd-c': !isHorizontal,
        'fd-r ai-c': isHorizontal,
      })}
    >
      <AdvancedSearchResultCardStatus state={state} contentType={contentType} />
      {isHorizontal && state && (
        <div className="AdvancedSearchResultCard-status-divider ml-8 mr-8" />
      )}
      <div className="d-f fd-r">
        {shouldShowType && (
          <AdvancedSearchContentTypeIcon
            contentType={contentType}
            certificationId={certificationId}
          />
        )}
        {shouldShowType && (
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>{typeText}</Text>
        )}
      </div>
    </div>
  );
}
